import { isAuthenticated } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'

export default [
  {
    name: 'shop',
    path: '/shop/:id',
    props: true,
    component: () =>
      LazyLoadView(import(/* webpackChunkName: "shop-dashboard" */ '@/views/Shop/Dashboard/Component.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'shop-mutate',
    path: '/shop/:id/edit',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "shop-mutate" */ '@/views/Shop/Mutate.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'shop-view',
    path: '/shop/:id/view',
    props: route => ({
      id: route.params.id,
      accessToken: route.query.accessToken,
    }),
    component: () => LazyLoadView(import(/* webpackChunkName: "shop-view" */ '@/views/Shop/View.vue')),
    meta: {
      skipAuth: true,
      navigation: false,
      footer: false,
    },
  },
  {
    name: 'shop-external',
    path: '/shop/:id/external',
    props: route => ({
      id: route.params.id,
      token: route.query.token,
      returnTo: route.query.returnTo,
    }),
    component: () => LazyLoadView(import(/* webpackChunkName: "shop-external" */ '@/views/Shop/External.vue')),
    meta: {
      skipAuth: true,
      navigation: false,
      footer: false,
    },
  },
  {
    name: 'shop-product',
    path: '/shop/product/:id',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "shop-product" */ '@/views/Shop/Product.vue')),
    meta: {
      skipAuth: true,
      navigation: false,
      footer: false,
    },
  },
]
